import { cn } from '@/shared/lib/utils';
import * as React from 'react';

interface FieldControlProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * Input/Select 등 단일 컨트롤 래퍼.
 * Radix Select가 form 안에서 삽입하는 hidden native &lt;select&gt;가
 * space-y/gap 레이아웃에 여백을 만들지 않도록 격리한다.
 */
export const FieldControl: React.FC<FieldControlProps> = ({
  className,
  children,
}) => (
  <div
    className={cn(
      'relative w-full [&_select[aria-hidden=true]]:sr-only',
      className,
    )}
  >
    {children}
  </div>
);
